import { logError } from '@iwLogger/IwDataDogLogger';

import { isTrackingSource, TrackingSource } from '../trackingSource';

const STORAGE_KEY = 'openBankingExtendIntent';

const MAX_AGE_MS = 15 * 60 * 1000;

type ExtendIntent = {
    onlineAccountId: string;
    source: TrackingSource;
    at: number;
};

export type ExtendIntentRecord = Pick<
    ExtendIntent,
    'onlineAccountId' | 'source'
>;

export const rememberExtendIntent = (
    onlineAccountId: string,
    source: TrackingSource
) => {
    try {
        const intent: ExtendIntent = {
            onlineAccountId,
            source,
            at: Date.now()
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
    } catch (error) {
        logError(
            'Open banking reconsent: could not remember the extend intent',
            {
                onlineAccountId,
                error: error instanceof Error ? error.message : 'Unknown error'
            }
        );
    }
};

export const peekExtendIntent = (): ExtendIntentRecord | null => {
    try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        if (!stored) return null;

        const intent = JSON.parse(stored) as ExtendIntent;
        if (
            typeof intent?.onlineAccountId !== 'string' ||
            typeof intent?.at !== 'number'
        ) {
            return null;
        }

        if (Date.now() - intent.at > MAX_AGE_MS) return null;

        return {
            onlineAccountId: intent.onlineAccountId,
            // A note left before this field existed still tells us the customer
            // came back from the bank, just not where they set out from.
            source: isTrackingSource(intent.source)
                ? intent.source
                : 'truelayer_return'
        };
    } catch {
        return null;
    }
};

export const forgetExtendIntent = () => {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        return;
    }
};
